export const brandSelectList = [
  {
    id: 1,
    title: "Nhà sản xuất",
    value: "manufacturer",
  },
  {
    id: 2,
    title: "Thương hiệu",
    value: "name",
  },
];
